export const short = [
  {
    name: 'welcomeEverydoggy',
  },
  {
    name: 'whatWeHaveForYou',
  },
  {
    name: 'trainYourDog',
  },
  {
    name: 'formingSkill',
  },
  {
    name: 'role',
  },
  {
    name: 'puppy_or_adult',
    role: 'wannabe',
  },
  {
    name: 'dog_name',
    role: 'haveDog',
  },
  {
    name: 'how_old',
    role: 'haveDog',
  },
  {
    name: 'breed',
    role: 'haveDog',
  },
];
